
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { hasRole, ROLE_ADMIN_MITRA, ROLE_ADMIN_PJO, ROLE_HSE, ROLE_BIB_HR_OPERATIONS_SITE, ROLE_BIB_HR_OPERATIONS_JAKARTA, ROLE_EMPLOYEE, ROLE_MANAGER, ROLE_HR } from "@/constants/mitraRole";
import DetailModal from "./components/DetailModal.vue";
import DatePickerModal from "./components/DatePickerModal.vue";
import EmployeeDetailSection from "./components/EmployeeDetailSection.vue";
import LoadingState from "@/components/LoadingState.vue";
import { REPORT_TYPE_OPTIONS } from "@/api/common/reports";

export default {
  name: "dashboard",
  components: {
    DetailModal,
    DatePickerModal,
    EmployeeDetailSection,
    LoadingState
  },
  data() {
    return {
      activeTab: 0,
      employeeDetailTab: 0,
      showDatePicker: false,
      isDashboardLoading: false,
      isRoleCompetenciesLoading: false,
      dashboardRequestSeq: 0,

      // Modal state
      showDetailModal: false,
      selectedRole: null,
      selectedSubCategory: null,

      // Filters
      filters: {
        company: null,
        kplhType: "KPLH",
        trainingType: "all",
        period: "This Year"
      },

      // Filter Options
      companyOptions: [],
      kplhOptions: [
        {
          label: 'KPLH',
          value: 'KPLH'
        },
        {
          label: 'NON KPLH',
          value: 'NON_KPLH'
        },
      ],
      trainingTypeOptions: [
        {
          label: 'All',
          value: 'all'
        },
        {
          label: 'Mandatory',
          value: 'mandatory'
        },
        {
          label: 'Development',
          value: 'development'
        },
      ],

      // Report Filters
      reportFilters: {
        reportType: null,
        company: null,
        competency: null,
        period: "This Year",
        startDate: null,
        endDate: null
      },

      // Report Filter Options (synced with src/api/common/reports.js)
      reportTypeOptions: REPORT_TYPE_OPTIONS,
      reportPeriodOptions: [
        "Today",
        "Yesterday",
        "This Week",
        "Last Week",
        "This Month",
        "Last Month",
        "Q1",
        "Q2",
        "Q3",
        "Q4",
        "Semester 1",
        "Semester 2",
        "This Year",
        "Last Year",
        "Custom"
      ],
      isLoadingCompetencyOptions: false,

      // Loading and error states for export
      isExporting: false,
      exportError: null,
      exportSuccess: null,

      // Report Table (restored)
      reportTableFields: [
        { key: 'no', label: 'NO', sortable: false, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'companyName', label: 'COMPANY NAME', sortable: true },
        { key: 'abbd', label: 'ABBD', sortable: true },
        { key: 'category', label: 'CATEGORY', sortable: true },
        { key: 'plan', label: 'PLAN', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actual', label: 'ACTUAL', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'percentage', label: '%', sortable: true, thClass: 'text-center', tdClass: 'text-center' }
      ],
      reportData: [
        { companyName: 'PT BORNEO INDOBARA', abbd: 'BIB', category: '-', plan: 75, actual: 67, percentage: '89.3%' },
        { companyName: 'CV Hamim Selamet Jaya', abbd: 'HSJ', category: 'Port & Project', plan: 'N/A', actual: 'N/A', percentage: 'N/A' },
        { companyName: 'Koperasi Mitra Bersatu', abbd: 'KMB', category: 'Hauling', plan: 1, actual: 1, percentage: '100%' },
        { companyName: 'PT Akatara Bintang Parawira', abbd: 'ABP', category: 'Others', plan: 1, actual: 0, percentage: '0%' },
        { companyName: 'PT Antareja Mahada Makmur', abbd: 'AMM', category: 'Hauling', plan: 2, actual: 2, percentage: '100%' },
        { companyName: 'PT Anugerah Energi Kalimantan', abbd: 'AEK', category: 'Hauling', plan: 2, actual: 2, percentage: '100%' },
        { companyName: 'PT Bangseng Delaka Makmur', abbd: 'BDM', category: 'Others', plan: 1, actual: 1, percentage: '100%' },
        { companyName: 'PT Bangun Arta Hutama', abbd: 'BAH', category: 'Port & Project', plan: 5, actual: 5, percentage: '100%' },
        { companyName: 'PT Bangun Bumi Wijaya', abbd: 'BBW', category: 'Port & Project', plan: 'N/A', actual: 'N/A', percentage: 'N/A' },
        { companyName: 'PT Banua Abadi Jaya', abbd: 'BAJ', category: 'Port & Project', plan: 'N/A', actual: 'N/A', percentage: 'N/A' },
        { companyName: 'PT Cakra Buana Mining', abbd: 'CBM', category: 'Hauling', plan: 3, actual: 3, percentage: '100%' },
        { companyName: 'PT Duta Sarana Internusa', abbd: 'DSI', category: 'Others', plan: 2, actual: 1, percentage: '50%' },
        { companyName: 'PT Energi Mega Persada', abbd: 'EMP', category: 'Port & Project', plan: 4, actual: 4, percentage: '100%' },
        { companyName: 'PT Fajar Surya Swadaya', abbd: 'FSS', category: 'Hauling', plan: 2, actual: 2, percentage: '100%' },
        { companyName: 'PT Guna Jaya Sakti', abbd: 'GJS', category: 'Others', plan: 1, actual: 0, percentage: '0%' },
        { companyName: 'PT Hasta Bangun Persada', abbd: 'HBP', category: 'Port & Project', plan: 6, actual: 5, percentage: '83.3%' },
        { companyName: 'PT Indo Mitra Makmur', abbd: 'IMM', category: 'Hauling', plan: 3, actual: 3, percentage: '100%' },
        { companyName: 'PT Jaya Konstruksi Pratama', abbd: 'JKP', category: 'Others', plan: 2, actual: 2, percentage: '100%' },
        { companyName: 'PT Karya Bersama Sejahtera', abbd: 'KBS', category: 'Hauling', plan: 4, actual: 4, percentage: '100%' },
        { companyName: 'PT Lestari Alam Nusantara', abbd: 'LAN', category: 'Port & Project', plan: 'N/A', actual: 'N/A', percentage: 'N/A' }
      ],
      reportCurrentPage: 1,
      reportPerPage: 10,

      // Date Range
      dateRange: {
        start: moment().startOf("year").toDate(),
        end: moment().endOf("day").toDate()
      },

      // Summary Data
      summaryData: {
        totalPlanned: 0,
        totalActual: 0,
        achieved: 0,
        plannedChange: "+1.01%",
        actualChange: "+0.49%",
        achievedChange: "-0.91%"
      },

      // Role Competency List (array for looping)
      roleCompetencyList: [
        {
          id: 1,
          title: "Pengawas Operasional",
          type: "complex", // complex = has sub-categories
          total: 95,
          color: "#E53935",
          items: [
            { name: "POP", percentage: 99, plan: 638, actual: 631 },
            { name: "POM", percentage: 86, plan: 58, actual: 50 },
            { name: "POU", percentage: 100, plan: 10, actual: 10 }
          ]
        },
        {
          id: 2,
          title: "Pengawas Teknis",
          type: "simple", // simple = no sub-categories
          total: 85,
          color: "#E53935",
          items: [
            { name: "POP", percentage: 99, plan: 638, actual: 631 },
            { name: "POM", percentage: 86, plan: 58, actual: 50 },
            { name: "POU", percentage: 100, plan: 10, actual: 10 }
          ]
        },
        {
          id: 3,
          title: "Tenaga Teknis",
          type: "simple",
          total: 91,
          color: "#E53935",
          items: [
            { name: "POP", percentage: 99, plan: 638, actual: 631 },
            { name: "POM", percentage: 86, plan: 58, actual: 50 },
            { name: "POU", percentage: 100, plan: 10, actual: 10 }
          ]
        },
        {
          id: 4,
          title: "Operator Produksi",
          type: "complex",
          total: 88,
          color: "#E53935",
          items: [
            { name: "OP1", percentage: 92, plan: 425, actual: 391 },
            { name: "OP2", percentage: 85, plan: 380, actual: 323 },
            { name: "OP3", percentage: 87, plan: 215, actual: 187 }
          ]
        },
        {
          id: 5,
          title: "Staff Administrasi",
          type: "simple",
          total: 94,
          color: "#E53935",
          items: [
            { name: "POP", percentage: 99, plan: 638, actual: 631 },
            { name: "POM", percentage: 86, plan: 58, actual: 50 },
            { name: "POU", percentage: 100, plan: 10, actual: 10 }
          ]
        },
        {
          id: 6,
          title: "Supervisor",
          type: "complex",
          total: 90,
          color: "#E53935",
          items: [
            { name: "SPV Production", percentage: 95, plan: 45, actual: 43 },
            { name: "SPV Maintenance", percentage: 88, plan: 38, actual: 33 },
            { name: "SPV Quality", percentage: 87, plan: 32, actual: 28 }
          ]
        }
      ],

      // BIB Role Competency (single item for Admin BIB)
      bibRoleCompetency: {
        id: 1,
        title: "Pengawas Operasional",
        type: "complex",
        total: 95,
        color: "#E53935",
        items: [
          { name: "POP", percentage: 99, plan: 638, actual: 631 },
          { name: "POM", percentage: 86, plan: 58, actual: 50 },
          { name: "POU", percentage: 100, plan: 10, actual: 10 }
        ]
      },

      // Chart Data — always keep series shape so ApexCharts never reads .length of undefined
      planActualSeries: [
        { name: "Planned", data: [] },
        { name: "Completed", data: [] }
      ],

      planActualChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        colors: ["#F9A825", "#4CAF50"],
        dataLabels: {
          enabled: true,
          offsetY: -18,
          style: {
            fontSize: "11px",
            fontWeight: 600,
            colors: ["#334155"]
          },
          background: {
            enabled: true,
            foreColor: "#334155",
            borderRadius: 3,
            opacity: 0.85,
            borderWidth: 0,
            padding: 3
          },
          formatter(value) {
            return Number(value) > 0 ? value : "";
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "34%",
            borderRadius: 4,
            borderRadiusApplication: "end",
            dataLabels: {
              position: "top"
            }
          }
        },
        stroke: {
          show: true,
          width: 0
        },
        fill: {
          type: "solid",
          opacity: 1
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          min: 0,
          max: 10,
          tickAmount: 5
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          floating: true,
          offsetY: 2,
          markers: {
            radius: 4
          },
          itemMargin: {
            horizontal: 12,
            vertical: 0
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (value) {
              return value;
            }
          }
        },
        grid: {
          borderColor: "#f1f1f1",
          strokeDashArray: 4,
          padding: {
            top: 36,
            right: 16,
            left: 8
          }
        },
        markers: {
          size: 0
        }
      }
    };
  },

  computed: {
    ...mapGetters('users', ['profileData']),
    ...mapGetters('competencyOptions', {
      competencyOptionsList: 'getCompetencyOptions'
    }),
    ...mapGetters('dashboard', [
      'dashboardSummaryPartner',
      'dashboardTimeSeriesPartner',
      'dashboardRoleCompetenciesPartner',
      'dashboardSummaryHSE',
      'dashboardTimeSeriesHSE',
      'dashboardRoleCompetenciesHSE',
      'dashboardSummarySite',
      'dashboardTimeSeriesSite',
      'dashboardRoleCompetenciesSite',
      'dashboardSummaryEmployee',
      'dashboardTimeSeriesEmployee',
      'dashboardDetailEmployee',
      'dashboardSummaryInternal',
      'dashboardTimeSeriesInternal',
      'dashboardRoleCompetenciesInternal',
      'dashboardCompetenciesInternal',
      'dashboardCompanyOptions',
      'dashboardTimeSeriesInternal',
      'dashboardRoleCompetenciesInternal'
    ]),

    currentUserRoles() {
      return [
        this.profileData?.role_id,
        ...(this.profileData?.roles_uenroll || []),
        ...(this.profileData?.roles_uenrol || [])
      ].filter(Boolean);
    },

    isAdminMitraRole() {
      return hasRole(this.currentUserRoles, ROLE_ADMIN_MITRA);
    },

    isPJORole() {
      return hasRole(this.currentUserRoles, ROLE_ADMIN_PJO);
    },

    isPartnerRole() {
      return (this.isAdminMitraRole || this.isPJORole);
    },

    isHSETrainingRole() {
      return hasRole(this.currentUserRoles, ROLE_HSE);
    },

    isHROperationsSiteRole() {
      return hasRole(this.currentUserRoles, ROLE_BIB_HR_OPERATIONS_SITE);
    },

    isHROperationsJakartaRole() {
      return hasRole(this.currentUserRoles, ROLE_BIB_HR_OPERATIONS_JAKARTA);
    },

    isHROpsRole() {
      return this.isHROperationsSiteRole || this.isHROperationsJakartaRole;
    },

    isHRRole() {
      return hasRole(this.currentUserRoles, ROLE_HR) || this.isHROpsRole;
    },

    isEmployeeRole() {
      return hasRole(this.currentUserRoles, ROLE_EMPLOYEE);
    },

    isManagerRole() {
      return hasRole(this.currentUserRoles, ROLE_MANAGER);
    },

    isBibCompanyEmployee() {
      const profile = this.profileData || {};
      const companyId = Number(profile.company_id || profile.companyId);
      if (companyId === 7003) {
        return true;
      }

      const companyValues = [
        profile.company,
        profile.company_name,
        profile.companyName,
        profile.business_unit,
        profile.business_unit_name,
        profile.unit,
        localStorage.getItem("company_name"),
        localStorage.getItem("company")
      ]
        .filter(Boolean)
        .map((value) => String(value).toLowerCase().replace(/\./g, " ").replace(/\s+/g, " ").trim());

      return companyValues.some((value) =>
        value.includes("borneo indobara") || value === "bib" || value.includes("pt borneo indobara")
      );
    },

    shouldShowEmployeeMitraTabs() {
      if (this.isHRRole || this.isHSETrainingRole) {
        return false;
      }

      return this.isEmployeeRole || this.isManagerRole || this.isBibCompanyEmployee;
    },

    canViewCompanyDetail() {
      if (this.isManagerRole || this.isPartnerRole || this.isHSETrainingRole || this.isHROpsRole) {
        return true;
      }

      return !this.isEmployeeRole;
    },

    // Computed property to return appropriate dashboard data based on role
    dashboardRoleCompetencies() {
      const normalizeRole = (role = {}) => ({
        ...role,
        trainings: Array.isArray(role.trainings) ? role.trainings : []
      });

      if (this.isPartnerRole) {
        return (this.dashboardRoleCompetenciesPartner || []).map(normalizeRole);
      } else if (this.isHSETrainingRole) {
        return (this.dashboardRoleCompetenciesHSE || []).map(normalizeRole);
      } else if (this.isHROpsRole) {
        // HR Operations Site
        if (this.isHROperationsSiteRole) {
          // Check if NON_KPLH filter
          if (this.filters.kplhType === 'NON_KPLH') {
            // Use competencies/internal - keep original id and competency fields
            return (this.dashboardCompetenciesInternal || []).map(item => ({
              id: item.id,
              competency: item.competency,
              total: item.total || 0,
              plan: item.total_submitted,
              actual: item.total_completed,
              trainings: (Array.isArray(item.trainings) ? item.trainings : []).map(training => ({
                id: training.id,
                name: training.name,
                percentage: training.percentage || 0,
                plan: training.submitted || 0,
                submitted: training.submitted || 0,
                actual: training.completed || 0,
                completed: training.completed || 0
              }))
            }));
          }
          // For KPLH, use data from Site API
          return (this.dashboardRoleCompetenciesSite || []).map(normalizeRole);
        }
        // HR Operations Jakarta
        else if (this.isHROperationsJakartaRole) {
          // Check if NON_KPLH filter
          if (this.filters.kplhType === 'NON_KPLH') {
            // Use competencies/internal - keep original id and competency fields
            return (this.dashboardCompetenciesInternal || []).map(item => ({
              id: item.id,
              competency: item.competency,
              total: item.total || 0,
              plan: item.total_submitted,
              actual: item.total_completed,
              trainings: (Array.isArray(item.trainings) ? item.trainings : []).map(training => ({
                id: training.id,
                name: training.name,
                percentage: training.percentage || 0,
                plan: training.submitted || 0,
                submitted: training.submitted || 0,
                actual: training.completed || 0,
                completed: training.completed || 0
              }))
            }));
          }
          // For KPLH, use data from Internal API
          return (this.dashboardRoleCompetenciesInternal || []).map(normalizeRole);
        }
      } else if (this.isEmployeeRole || this.isManagerRole) {
        if (this.filters.kplhType === 'NON_KPLH') {
          return (this.dashboardCompetenciesInternal || []).map(item => ({
            id: item.id,
            competency: item.competency,
            role_competency_title: item.competency,
            total: item.total || 0,
            plan: item.total_submitted,
            actual: item.total_completed,
            trainings: (Array.isArray(item.trainings) ? item.trainings : []).map(training => ({
              id: training.id,
              name: training.name,
              percentage: training.percentage || 0,
              plan: training.submitted || 0,
              submitted: training.submitted || 0,
              actual: training.completed || 0,
              completed: training.completed || 0
            }))
          }));
        }

        return (this.dashboardRoleCompetenciesHSE || []).map(normalizeRole);
      } else if (this.shouldShowEmployeeMitraTabs && this.filters.kplhType === 'NON_KPLH') {
        return (this.dashboardCompetenciesInternal || []).map(item => ({
          id: item.id,
          competency: item.competency,
          role_competency_title: item.competency,
          total: item.total || 0,
          plan: item.total_submitted,
          actual: item.total_completed,
          trainings: (Array.isArray(item.trainings) ? item.trainings : []).map(training => ({
            id: training.id,
            name: training.name,
            percentage: training.percentage || 0,
            plan: training.submitted || 0,
            submitted: training.submitted || 0,
            actual: training.completed || 0,
            completed: training.completed || 0
          }))
        }));
      }
      // Default to internal for other roles
      return (this.dashboardRoleCompetenciesInternal || []).map(normalizeRole);
    },

    shouldShowRoleCompetencySection() {
      return !this.shouldShowEmployeeMitraTabs;
    },

    formattedDateRange() {
      const start = moment(this.dateRange.start).format("DD/MM/YYYY");
      const end = moment(this.dateRange.end).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },

    reportTotalRows() {
      return this.reportData.length;
    },

    // Show custom date inputs only when period is "Custom"
    showCustomDateInputs() {
      return this.reportFilters.period === "Custom";
    },

    // Formatted date range for report display
    formattedReportDateRange() {
      if (this.reportFilters.period === "Custom" && this.reportFilters.startDate && this.reportFilters.endDate) {
        const start = moment(this.reportFilters.startDate).format("DD/MM/YYYY");
        const end = moment(this.reportFilters.endDate).format("DD/MM/YYYY");
        return `${start} - ${end}`;
      }
      return this.reportFilters.period;
    },

    reportCompetencyOptions() {
      return (this.competencyOptionsList || []).map((item) => ({
        value: item.id,
        label: item.competency_name || item.name || item.id
      }));
    },

    showReportCompanyFilter() {
      return !this.isPartnerRole;
    },

    showReportCompetencyFilter() {
      return !this.isPartnerRole;
    }
  },

  watch: {
    '$route.query.tab': {
      handler(tab) {
        this.setActiveTabFromRoute(tab);
      },
      immediate: true
    },
    'filters.kplhType'() {
      // Fetch data when KPLH filter changes
      this.fetchDashboardData();
    },
    'filters.company'() {
      // Fetch data when company filter changes
      this.fetchDashboardData();
    },
    'filters.trainingType'() {
      // Fetch data when Training Type filter changes
      this.fetchDashboardData();
    },
    activeTab(tab) {
      if (tab === 0) {
        this.$nextTick(() => {
          this.fetchDashboardData();
        });
      }
    },
    profileData: {
      handler(newVal) {
        // Fetch data when profile data is loaded
        if (newVal && newVal.roles_uenroll) {
          if (!this.showReportCompanyFilter) {
            this.reportFilters.company = null;
          }
          if (!this.showReportCompetencyFilter) {
            this.reportFilters.competency = null;
          }
          this.fetchDashboardData();
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('competencyOptions', ['getAllCompetencies']),
    ...mapActions('dashboard', [
      'getDashboardSummaryPartner',
      'getDashboardTimeSeriesPartner',
      'getDashboardRoleCompetenciesPartner',
      'getDashboardSummaryHSE',
      'getDashboardTimeSeriesHSE',
      'getDashboardRoleCompetenciesHSE',
      'getDashboardSummarySite',
      'getDashboardTimeSeriesSite',
      'getDashboardRoleCompetenciesSite',
      'getDashboardSummaryEmployee',
      'getDashboardTimeSeriesEmployee',
      'getDashboardDetailEmployee',
      'getDashboardSummaryInternal',
      'getDashboardTimeSeriesInternal',
      'getDashboardRoleCompetenciesInternal',
      'getDashboardCompetenciesInternal',
      'getDashboardCompanyOptions',
      'getDashboardTimeSeriesInternal',
      'getDashboardRoleCompetenciesInternal',
      'exportDashboardReport'
    ]),

    async fetchCompanyOptions() {
      try {
        const response = await this.getDashboardCompanyOptions({ limit: 500 });
        this.companyOptions = response?.data || this.dashboardCompanyOptions || [];
      } catch (error) {
        console.error("Error fetching company options:", error);
        this.companyOptions = this.dashboardCompanyOptions || [];
      }
    },

    async fetchCompetencyOptions() {
      this.isLoadingCompetencyOptions = true;
      try {
        await this.getAllCompetencies();
      } catch (error) {
        console.error("Error fetching competency options:", error);
      } finally {
        this.isLoadingCompetencyOptions = false;
      }
    },

    setActiveTabFromRoute(tabQuery) {
      console.log(tabQuery);
      const tabValue = String(tabQuery || '').toLowerCase();
      this.activeTab = tabValue == 'report' ? 1 : 0;
    },

    setReportTypeFromRoute(reportTypeQuery) {
      const reportTypeValue = String(reportTypeQuery || '').toLowerCase();
      const selectedReportType = this.reportTypeOptions.find((option) => option.value === reportTypeValue);

      if (selectedReportType) {
        this.reportFilters.reportType = selectedReportType;
      }
    },

    closeDatePicker() {
      this.showDatePicker = false;
    },

    applyDateRange(data) {
      this.filters.period = data.period;
      this.dateRange.start = data.startDate;
      this.dateRange.end = data.endDate;
      this.showDatePicker = false;
      this.fetchDashboardData();
    },

    async fetchDashboardRoleCompetencies(queryParams, requestSeq) {
      if (!this.shouldShowRoleCompetencySection && !this.shouldShowEmployeeMitraTabs) return;

      this.isRoleCompetenciesLoading = true;
      try {
        if (this.isPartnerRole) {
          await this.getDashboardRoleCompetenciesPartner({
            start_date: queryParams.start_date,
            end_date: queryParams.end_date,
            training_type: queryParams.training_type || "all"
          });
        } else if (this.isHROperationsSiteRole) {
          if (this.filters.kplhType === 'NON_KPLH') {
            await this.getDashboardCompetenciesInternal({
              ...queryParams,
              matrix_kplh: 'NON_KPLH'
            });
          } else {
            await this.getDashboardRoleCompetenciesSite(queryParams);
          }
        } else if (this.isHROperationsJakartaRole) {
          if (this.filters.kplhType === 'NON_KPLH') {
            await this.getDashboardCompetenciesInternal({
              ...queryParams,
              matrix_kplh: 'NON_KPLH'
            });
          } else {
            await this.getDashboardRoleCompetenciesInternal(queryParams);
          }
        } else if (this.isHSETrainingRole || this.isEmployeeRole || this.isManagerRole || this.shouldShowEmployeeMitraTabs) {
          if (this.shouldShowEmployeeMitraTabs && !this.isHSETrainingRole && this.filters.kplhType === 'NON_KPLH') {
            await this.getDashboardCompetenciesInternal({
              ...queryParams,
              matrix_kplh: 'NON_KPLH'
            });
          } else if (this.isHSETrainingRole || this.isEmployeeRole || this.isManagerRole) {
            await this.getDashboardRoleCompetenciesHSE(queryParams);
          } else {
            await this.getDashboardRoleCompetenciesInternal(queryParams);
          }
        } else {
          await this.getDashboardRoleCompetenciesInternal(queryParams);
        }
      } catch (error) {
        console.error("Error fetching dashboard role competencies:", error);
      } finally {
        if (requestSeq === this.dashboardRequestSeq) {
          this.isRoleCompetenciesLoading = false;
        }
      }
    },

    async fetchDashboardData() {
      // Guard: Pastikan profileData sudah ready
      if (!this.profileData || !this.profileData.roles_uenroll || this.profileData.roles_uenroll.length === 0) {
        console.log("Profile data not ready yet");
        return;
      }

      const requestSeq = ++this.dashboardRequestSeq;
      this.isDashboardLoading = true;
      this.isRoleCompetenciesLoading = false;

      try {
        // Format dates to MM/DD/YYYY
        const startDate = moment(this.dateRange.start).format("MM/DD/YYYY");
        const endDate = moment(this.dateRange.end).format("MM/DD/YYYY");

        // Prepare query params — training_type: all | mandatory | development
        const queryParams = {
          start_date: startDate,
          end_date: endDate,
          matrix_kplh: this.filters.kplhType || "KPLH",
          company: this.filters.company || null,
          training_type: this.filters.trainingType || "all"
        };

        console.log("Fetching dashboard summary with:", queryParams);

        // Call appropriate Vuex actions based on role
        if (this.isPartnerRole) {
          // GET /dashboard/summary|time-series|role-competencies/partner?training_type=
          const partnerParams = {
            start_date: startDate,
            end_date: endDate,
            training_type: this.filters.trainingType || "all"
          };
          await Promise.all([
            this.getDashboardSummaryPartner(partnerParams),
            this.getDashboardTimeSeriesPartner(partnerParams)
          ]);
          if (requestSeq !== this.dashboardRequestSeq) return;

          // Update local summaryData from partner store
          this.summaryData.totalPlanned = this.dashboardSummaryPartner.totalPlanned || 0;
          this.summaryData.totalActual = this.dashboardSummaryPartner.totalActual || 0;
          this.summaryData.achieved = this.dashboardSummaryPartner.achieved || 0;

          this.updatePlanActualChart(this.dashboardTimeSeriesPartner);
          this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
        } else if (this.isHSETrainingRole) {
          // Use HSE APIs for HSE Training
          await Promise.all([
            this.getDashboardSummaryHSE(queryParams),
            this.getDashboardTimeSeriesHSE(queryParams)
          ]);
          if (requestSeq !== this.dashboardRequestSeq) return;

          // Update local summaryData from HSE store
          this.summaryData.totalPlanned = this.dashboardSummaryHSE.totalPlanned || 0;
          this.summaryData.totalActual = this.dashboardSummaryHSE.totalActual || 0;
          this.summaryData.achieved = this.dashboardSummaryHSE.achieved || 0;

          this.updatePlanActualChart(this.dashboardTimeSeriesHSE);
          this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
        } else if (this.isHROpsRole) {
          // HR Operations Site vs Jakarta
          if (this.isHROperationsSiteRole) {
            await Promise.all([
              this.getDashboardSummarySite(queryParams),
              this.getDashboardTimeSeriesSite(queryParams)
            ]);
            if (requestSeq !== this.dashboardRequestSeq) return;

            // Update local summaryData from SITE store
            this.summaryData.totalPlanned = this.dashboardSummarySite.totalPlanned || 0;
            this.summaryData.totalActual = this.dashboardSummarySite.totalActual || 0;
            this.summaryData.achieved = this.dashboardSummarySite.achieved || 0;

            this.updatePlanActualChart(this.dashboardTimeSeriesSite);
            this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
          } else if (this.isHROperationsJakartaRole) {
            await Promise.all([
              this.getDashboardSummaryInternal(queryParams),
              this.getDashboardTimeSeriesInternal(queryParams)
            ]);
            if (requestSeq !== this.dashboardRequestSeq) return;

            // Update local summaryData from INTERNAL store
            this.summaryData.totalPlanned = this.dashboardSummaryInternal.totalPlanned || 0;
            this.summaryData.totalActual = this.dashboardSummaryInternal.totalActual || 0;
            this.summaryData.achieved = this.dashboardSummaryInternal.achieved || 0;

            this.updatePlanActualChart(this.dashboardTimeSeriesInternal);
            this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
          }
        } else if (this.isEmployeeRole || this.isManagerRole) {
          // Use Employee APIs for Employee role
          await Promise.all([
            this.getDashboardSummaryEmployee(queryParams),
            this.getDashboardTimeSeriesEmployee(queryParams)
          ]);
          if (requestSeq !== this.dashboardRequestSeq) return;

          // Update local summaryData from employee store
          this.summaryData.totalPlanned = this.dashboardSummaryEmployee.totalPlanned || 0;
          this.summaryData.totalActual = this.dashboardSummaryEmployee.totalActual || 0;
          this.summaryData.achieved = this.dashboardSummaryEmployee.achieved || 0;

          this.updatePlanActualChart(this.dashboardTimeSeriesEmployee);
          this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
        } else {
          // Use internal APIs for Internal (hr, hropsjakarta, hr-lnd, dll)
          await Promise.all([
            this.getDashboardSummaryInternal(queryParams),
            this.getDashboardTimeSeriesInternal(queryParams)
          ]);
          if (requestSeq !== this.dashboardRequestSeq) return;

          // Update local summaryData from internal store
          this.summaryData.totalPlanned = this.dashboardSummaryInternal.totalPlanned || 0;
          this.summaryData.totalActual = this.dashboardSummaryInternal.totalActual || 0;
          this.summaryData.achieved = this.dashboardSummaryInternal.achieved || 0;

          this.updatePlanActualChart(this.dashboardTimeSeriesInternal);
          this.fetchDashboardRoleCompetencies(queryParams, requestSeq);
        }

        console.log("Dashboard summary updated:", this.summaryData);
        console.log("Dashboard chart updated:", this.planActualSeries);
      } catch (error) {
        console.error("Error fetching dashboard summary:", error);
        // Keep chart in a safe empty state so ApexCharts does not crash
        this.updatePlanActualChart({ planned: [], completed: [], xLabel: [] });
      } finally {
        if (requestSeq === this.dashboardRequestSeq) {
          this.isDashboardLoading = false;
        }
      }
    },

    buildPlanActualYAxis(series = []) {
      const values = (Array.isArray(series) ? series : [])
        .flatMap((item) => (Array.isArray(item?.data) ? item.data : []))
        .map((value) => Number(value) || 0);
      const maxValue = values.length ? Math.max(...values, 0) : 0;
      const paddedMax = maxValue <= 0 ? 10 : maxValue * 1.15;
      const magnitude = Math.pow(10, Math.max(String(Math.floor(paddedMax)).length - 2, 0));
      const roundedMax = Math.ceil(paddedMax / magnitude) * magnitude;

      return {
        min: 0,
        max: Math.max(roundedMax, 10),
        tickAmount: 5,
        decimalsInFloat: 0,
        labels: {
          formatter(value) {
            return Math.round(value);
          }
        }
      };
    },

    normalizePlanActualSeries(planned, completed) {
      return [
        {
          name: "Planned",
          data: Array.isArray(planned) ? planned : []
        },
        {
          name: "Completed",
          data: Array.isArray(completed) ? completed : []
        }
      ];
    },

    updatePlanActualChart(timeSeries = {}) {
      this.planActualSeries = this.normalizePlanActualSeries(
        timeSeries.planned,
        timeSeries.completed
      );

      this.planActualChartOptions = {
        ...this.planActualChartOptions,
        xaxis: {
          ...this.planActualChartOptions.xaxis,
          categories: Array.isArray(timeSeries.xLabel) && timeSeries.xLabel.length
            ? timeSeries.xLabel
            : this.planActualChartOptions.xaxis.categories
        },
        yaxis: this.buildPlanActualYAxis(this.planActualSeries)
      };
    },

    getRadialChartOptions(value, color) {
      return {
        chart: {
          type: "radialBar",
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            hollow: {
              size: "60%"
            },
            track: {
              background: "#f2f2f2",
              strokeWidth: "100%"
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 5,
                fontSize: "24px",
                fontWeight: "bold",
                color: color,
                formatter: function (val) {
                  return val + "%";
                }
              }
            }
          }
        },
        colors: [color],
        stroke: {
          lineCap: "round"
        }
      };
    },

    getProgressVariant(percentage) {
      if (percentage >= 90) return "success";
      if (percentage >= 70) return "info";
      if (percentage >= 50) return "warning";
      return "danger";
    },

    getFirstTraining(role) {
      return Array.isArray(role?.trainings) && role.trainings.length > 0
        ? role.trainings[0]
        : null;
    },

    viewDetail(roleTitle, subCategory = null) {
      if (!this.canViewCompanyDetail) {
        return;
      }
      // Find the role by title from appropriate data source based on role
      const role = this.dashboardRoleCompetencies.find(r =>
        r.role_competency_title === roleTitle || r.competency === roleTitle
      );

      if (!role) {
        console.warn("Dashboard detail role not found:", roleTitle);
        return;
      }

      this.selectedRole = {
        title: roleTitle,
        id: role.id || role.role_competency_id || null
      };

      if (!this.selectedRole.id) {
        console.warn("Dashboard detail role has no id:", roleTitle, role);
        return;
      }

      this.selectedSubCategory = subCategory;
      this.showDetailModal = true;

      console.log("View detail for:", roleTitle, subCategory, "Role ID:", this.selectedRole.id);
    },

    closeDetailModal() {
      this.showDetailModal = false;
      this.selectedRole = null;
      this.selectedSubCategory = null;
    },

    // Update report date range based on period selection
    updateReportDateRange() {
      const today = moment();

      switch (this.reportFilters.period) {
        case "Today":
          this.reportFilters.startDate = today.clone().startOf('day').toDate();
          this.reportFilters.endDate = today.clone().endOf('day').toDate();
          break;
        case "Yesterday":
          this.reportFilters.startDate = today.clone().subtract(1, 'day').startOf('day').toDate();
          this.reportFilters.endDate = today.clone().subtract(1, 'day').endOf('day').toDate();
          break;
        case "This Week":
          this.reportFilters.startDate = today.clone().startOf('week').toDate();
          this.reportFilters.endDate = today.clone().endOf('week').toDate();
          break;
        case "Last Week":
          this.reportFilters.startDate = today.clone().subtract(1, 'week').startOf('week').toDate();
          this.reportFilters.endDate = today.clone().subtract(1, 'week').endOf('week').toDate();
          break;
        case "This Month":
          this.reportFilters.startDate = today.clone().startOf('month').toDate();
          this.reportFilters.endDate = today.clone().endOf('month').toDate();
          break;
        case "Last Month":
          this.reportFilters.startDate = today.clone().subtract(1, 'month').startOf('month').toDate();
          this.reportFilters.endDate = today.clone().subtract(1, 'month').endOf('month').toDate();
          break;
        case "Q1":
          this.reportFilters.startDate = today.clone().month(0).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(2).endOf('month').toDate();
          break;
        case "Q2":
          this.reportFilters.startDate = today.clone().month(3).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(5).endOf('month').toDate();
          break;
        case "Q3":
          this.reportFilters.startDate = today.clone().month(6).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(8).endOf('month').toDate();
          break;
        case "Q4":
          this.reportFilters.startDate = today.clone().month(9).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(11).endOf('month').toDate();
          break;
        case "Semester 1":
          this.reportFilters.startDate = today.clone().month(0).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(5).endOf('month').toDate();
          break;
        case "Semester 2":
          this.reportFilters.startDate = today.clone().month(6).startOf('month').toDate();
          this.reportFilters.endDate = today.clone().month(11).endOf('month').toDate();
          break;
        case "This Year":
          this.reportFilters.startDate = today.clone().startOf('year').toDate();
          this.reportFilters.endDate = today.clone().endOf('year').toDate();
          break;
        case "Last Year":
          this.reportFilters.startDate = today.clone().subtract(1, 'year').startOf('year').toDate();
          this.reportFilters.endDate = today.clone().subtract(1, 'year').endOf('year').toDate();
          break;
        case "Custom":
          // Keep existing dates or set to null
          if (!this.reportFilters.startDate) {
            this.reportFilters.startDate = today.clone().startOf('month').toDate();
          }
          if (!this.reportFilters.endDate) {
            this.reportFilters.endDate = today.clone().endOf('month').toDate();
          }
          break;
      }
    },

    async exportReport() {
      // Validation
      if (!this.reportFilters.reportType) {
        this.$bvToast.toast("Pilih tipe laporan", {
          title: "Validasi Gagal",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000,
          toaster: 'b-toaster-top-right'
        });
        return;
      }

      if (!this.reportFilters.startDate || !this.reportFilters.endDate) {
        this.$bvToast.toast("Pilih tanggal mulai dan tanggal selesai", {
          title: "Validasi Gagal",
          variant: "danger",
          solid: true,
          autoHideDelay: 3000,
          toaster: 'b-toaster-top-right'
        });
        return;
      }

      try {
        this.isExporting = true;
        this.exportError = null;
        this.exportSuccess = null;

        // Payload for POST /common/reports
        const payload = {
          type: this.reportFilters.reportType.value,
          start_date: moment(this.reportFilters.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.reportFilters.endDate).format("YYYY-MM-DD"),
          company: this.showReportCompanyFilter ? (this.reportFilters.company || undefined) : undefined,
          competency_id: this.showReportCompetencyFilter ? (this.reportFilters.competency || undefined) : undefined
        };

        // Call export API
        const response = await this.exportDashboardReport(payload);

        // Create blob from response
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // Generate filename
        const startDateStr = moment(this.reportFilters.startDate).format("YYYYMMDD");
        const endDateStr = moment(this.reportFilters.endDate).format("YYYYMMDD");
        const reportTypeName = this.reportFilters.reportType.label.replace(/\s+/g, '_');
        const filename = `UGEMS_Report_${reportTypeName}_${startDateStr}_${endDateStr}.xlsx`;

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(url);
        }, 100);

        // Set success message
        this.exportSuccess = `File "${filename}" berhasil diunduh!`;

        // Success notification with more details
        this.$bvToast.toast(`File "${filename}" berhasil diunduh!`, {
          title: "✅ Export Successful",
          variant: "success",
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-right',
          appendToast: false
        });

        console.log("Report exported successfully:", filename);

        // Clear success message after 5 seconds
        setTimeout(() => {
          this.exportSuccess = null;
        }, 5000);

      } catch (error) {
        console.error("Error exporting report:", error);

        // Parse error message
        let errorMessage = "Laporan belum berhasil diekspor. Silakan coba lagi.";
        if (error.response?.data) {
          // Check if error.response.data is a Blob (error response might be JSON in Blob format)
          if (error.response.data instanceof Blob) {
            try {
              const text = await error.response.data.text();
              const errorData = JSON.parse(text);
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              console.error("Failed to parse error blob:", e);
            }
          } else {
            errorMessage = error.response.data.message || error.response.data.error || errorMessage;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.exportError = errorMessage;

        // Error notification
        this.$bvToast.toast(errorMessage, {
          title: "❌ Export Failed",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-right',
          appendToast: false
        });

        // Clear error message after 5 seconds
        setTimeout(() => {
          this.exportError = null;
        }, 5000);
      } finally {
        this.isExporting = false;
      }
    },

    generateReport() {
      console.log("Generating report...");
      // TODO: Implement report generation
    },

    isMinimalistCard(title) {
      if (!this.shouldShowEmployeeMitraTabs && !this.isHROpsRole) return false;
      if (this.filters.kplhType !== 'NON_KPLH') return false;
      return title === 'Management Competency' || title === 'Technical Competency';
    },

    getRoleCompetencyClass(title) {
      if (this.isMinimalistCard(title)) {
        return "col-12 col-md-6";
      }
      return "col-12";
    },

    getRadialClass(title) {
      if (this.isMinimalistCard(title)) {
        return "col-12";
      }
      return "col-12 col-md-3";
    }
  },

  mounted() {
    this.setActiveTabFromRoute(this.$route?.query?.tab);
    this.setReportTypeFromRoute(this.$route?.query?.reportType);
    this.fetchCompanyOptions();
    this.fetchCompetencyOptions();

    // Initialize with This Year
    this.dateRange.start = moment().startOf("year").toDate();
    this.dateRange.end = moment().endOf("day").toDate();
    this.filters.period = "This Year";

    // Initialize report filters with This Year
    this.reportFilters.period = "This Year";
    this.updateReportDateRange();

    this.$nextTick(() => {
      this.fetchDashboardData();
    });
  }
};
